<div class="header-container" [class.minimal]="minimal()">
  <div class="title-row flex items-center justify-between gap-4">
    <div class="flex min-w-0 flex-1 items-center gap-1.5">
      <ng-container *ngIf="config$ | async as config">
        <mat-icon
          *ngIf="config.display?.icon?.slug"
          class="item-icon shrink-0"
          [ngStyle]="{ color: config.display.colour.value }"
          [svgIcon]="config.display.icon.slug"
        />
        <h4
          class="item-name"
          [matTooltip]="config.name"
          [matTooltipShowDelay]="300"
          [ngClass]="{ compact: compact }"
        >
          {{ config.name }}
        </h4>
      </ng-container>
      <ng-container *ngIf="item$ | async as item">
        <mat-icon
          *ngIf="item.notes.length"
          class="note shrink-0"
          [matTooltip]="noteTooltipText$ | async"
        >
          description
        </mat-icon>
      </ng-container>
    </div>
  </div>
  <div class="content-row flex flex-1 items-center gap-2">
    <ng-content select=".drag-handle" />
    <ng-content select=".checkbox" />
    <ng-content select=".attributed-to" />
    <ng-content select=".change-treatment-package" />
    <ng-container *ngIf="item$ | async as item">
      <pr-charted-items-surface-list
        *ngIf="config$ | async as config"
        [chartedSurfaces]="item.chartedSurfaces"
        [availableSurfaces]="config.availableSurfaces"
        [ngClass]="{ highlighted: highlighted }"
        [disabled]="item | map: isMultiTreatment"
        (editSurfaces)="editSurfaces.emit()"
      />
    </ng-container>
    <ng-content select=".header-info" />
    <span class="flex-1"></span>
    <!-- Note icon only visible in minimal mode -->
    <ng-container *ngIf="item$ | async as item">
      <mat-icon
        *ngIf="item.notes.length"
        class="note note-minimal shrink-0"
        [matTooltip]="noteTooltipText$ | async"
      >
        description
      </mat-icon>
    </ng-container>
    <!-- Price visible in normal mode (inside content row) -->
    <span class="price price-normal">{{ price$ | async | currency }}</span>
  </div>

  <!-- Action buttons - positioned by CSS based on mode -->
  <div class="action-buttons flex shrink-0 items-center gap-0.5">
    <ng-content select=".header-buttons" />
  </div>

  <!-- Price - positioned by CSS based on mode (separate for minimal) -->
  <span class="price price-minimal">{{ price$ | async | currency }}</span>

  <ng-content />
</div>
